import React from 'react';
import { IconButton, Typography } from '@material-ui/core';
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa';

import { useStyles } from './styles';

interface IYearSelector {
  value: number;
  onChange: (year: number) => void;
}

const YearSelector: React.FC<IYearSelector> = ({
  value,
  onChange,
  ...rest
}) => {
  const classes = useStyles();

  return (
    <div className={classes.container} {...rest}>
      <IconButton
        size="small"
        className={classes.decrease}
        onClick={() => onChange(value - 1)}
      >
        <FaAngleLeft size={16} color="#333333" />
      </IconButton>
      <Typography variant="body1" className={classes.year}>
        {value}
      </Typography>
      <IconButton
        size="small"
        className={classes.increase}
        onClick={() => onChange(value + 1)}
      >
        <FaAngleRight size={16} color="#333333" />
      </IconButton>
    </div>
  );
};

export default YearSelector;
